import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { hero } from "../../../datos";

export function Hero({ seccion }) {
  const [data, setData] = useState({});

  useEffect(() => {
    const dato = hero.filter((item) => (seccion ? item.seccion === seccion : true));
    setData(dato[0] || {});
  }, [seccion]);

  const isFullScreen = data.seccion === "home" || data.seccion === "recursohumano";

  return (
    <section
      className={`relative flex flex-col overflow-hidden ${isFullScreen ? "min-h-[100svh]" : "min-h-[260px] md:min-h-[360px] pt-16 md:pt-20"} bg-center bg-cover`}
      style={{ backgroundImage: `url(${data.image})` }}
    >
      {/* Gradient Overlay — azul marino a negro */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#151C84]/90 via-[#0d125c]/80 to-black/85" />

      {/* Geometric accent — círculo rojo decorativo */}
      <div className="absolute top-0 right-0 w-[200px] h-[200px] sm:w-[500px] sm:h-[500px] rounded-full bg-[#C81416]/10 -translate-y-1/3 translate-x-1/4 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[150px] h-[150px] sm:w-[300px] sm:h-[300px] rounded-full bg-[#151C84]/30 translate-y-1/3 -translate-x-1/4 blur-2xl pointer-events-none" />

      {/* Diagonal accent line */}
      {isFullScreen && (
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#C81416] via-[#C81416]/60 to-transparent" />
      )}

      {/* Content */}
      <div className="relative flex-1 flex items-center">
        <div className={`mx-auto px-4 w-full max-w-5xl ${isFullScreen ? "text-center" : "text-center py-8"}`}>

          {/* Eyebrow badge */}
          {isFullScreen && (
            <div
              className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-white/90 text-sm font-semibold mb-8 animate-fade-in"
              data-aos="fade-down"
              data-aos-delay="200"
            >
              <span className="w-2 h-2 rounded-full bg-[#C81416] animate-pulse" />
              Distribuidores Líderes en República Dominicana
            </div>
          )}

          {/* Title */}
          <h1
            className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight drop-shadow-xl animate-slide-up"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            {data?.title}
          </h1>

          {/* Subtitle */}
          {data?.subtitle && (
            <p
              className="text-lg md:text-xl mt-6 text-white/75 max-w-2xl mx-auto font-light leading-relaxed animate-slide-up"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              {data?.subtitle}
            </p>
          )}

          {/* CTAs */}
          {data?.btnText && (
            <div
              className="flex flex-col sm:flex-row gap-4 justify-center mt-10 animate-fade-in"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <Link
                to={data?.url}
                className="group inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#C81416] hover:bg-[#8c0e0f] text-white font-bold text-base rounded-xl transition-all duration-300 shadow-[0_4px_20px_rgba(200,20,22,0.45)] hover:shadow-[0_6px_28px_rgba(200,20,22,0.6)] hover:-translate-y-1"
              >
                {data?.btnText}
                <svg className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
              <Link
                to="/contacto"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-white/30 hover:border-white/70 text-white font-semibold text-base rounded-xl transition-all duration-300 hover:bg-white/10 backdrop-blur-sm"
              >
                Contáctanos
              </Link>
            </div>
          )}

          {/* Scroll indicator */}
          {isFullScreen && (
            <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40 text-xs font-medium animate-float">
              <span>Scroll</span>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          )}
        </div>
      </div>

      {/* Bottom gradient fade to page */}
      {isFullScreen && (
        <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-[#FBFAFA] to-transparent pointer-events-none" />
      )}
    </section>
  );
}
